/**
 * 统一定制弹出框
 */
import React, { useContext } from 'react';
import { Modal as ATModal } from 'antd';
import { ModalCustomProps } from './ts-config';
import styles from './index.module.less';
import { MainAppContext } from '@/index';

const Modal: React.FC<ModalCustomProps> = (props) => {
  const { container } = useContext(MainAppContext);
  const { visible, open, ...restProps } = props;
  return (
    <ATModal
      className={styles.modal}
      getContainer={() => {
        return container ? container.querySelector('#popContainer') : document.querySelector('#popContainer');
      }}
      {...restProps}
      open={visible || open}
    />
  );
};

export default Modal;
